import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20background%20with%20soft%20geometric%20shapes%20in%20cream%20and%20golden%20amber%20tones%2C%20subtle%20gradient%20overlay%2C%20clean%20modern%20design%2C%20digital%20information%20discovery%20theme%2C%20no%20text%2C%20no%20people%2C%20atmospheric%20and%20elegant&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="91暗指南背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
          探索<span className="text-primary-300">91暗</span>的完整指南
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          深度解析91暗的核心含义、使用场景与相关资源，帮助您快速了解91暗的全貌，
          找到最符合需求的内容与入口，是探索91暗不可错过的权威参考页面。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/rumen-zhinan"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/category/rukou-dizhi"
            className="w-full sm:w-auto px-8 py-3 bg-white/15 text-white font-medium text-sm rounded-lg hover:bg-white/25 backdrop-blur-sm border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看91暗入口
          </Link>
        </div>
      </div>
    </section>
  );
}